<template>
    <Button :label="$t('assign_customer_vendor')" icon="pi pi-check-circle" class="p-button-success p-button-sm mr-2" @click="onShowModal" />

    <CustomSidebar v-model:visible="showModal" position="bottom" :dismissable="false" :title="$t('assign_customer_vendor')" class="p-1" :blocked="blocked">
        <template #actions>
            <Button icon="pi pi-save" class="p-button p-button-success mr-1" :label="$t('assign_customer_vendor')" @click="save()"></Button>
        </template>
 
        <div class="flex" style="width:calc(100% - 2rem)">
            <div class="col-4 md-4 p-fluid">
                <ModalDataSAPOrder :data="orderData" v-if="orderData"/>     
            </div>
            <Divider layout="vertical" />
            <div class="col-8 md-4 p-fluid">
                <DataTable :value="orderData ? orderData.Details : null" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                    <Column field="Item_No" :header="$t('item_no')" key="Item_No">  
                    </Column>
                    <Column field="material_name" header="Material" key="material_name">
                    </Column>
                     <Column field="Qty" :header="$t('qty')" key="Active" style="width:15%">
                        <template #body="slotProps">
                            <InputNumber v-model="slotProps.data['Qty']" :max="slotProps.data['os_qty']"/>
                        </template>
                    </Column>
                    <Column field="os_qty" :header="$t('os_qty')" key="Active" style="width:15%">
                        <template #body="slotProps">
                            {{this.$formatNumber(slotProps.data[slotProps.column.props.field])}}
                        </template>
                    </Column>
                    <Column field="UOM" header="UOM" key="Active" style="width:10%">
                    </Column>
                </DataTable>

                <Divider />

                <ScrollPanel style="width:100%;height: 28vw">
                    <AssignTransporter 
                        :transporters="transporters" 
                        :isIndividual="isIndividual"
                        :isRelation="true"
                        :assignModel="assignModel"
                        :selectTransporterNumTrip="selectTransporterNumTrip"
                        :materials="materialDataModel"
                        :data="data"
                        :sapOrders="sapOrders"
                        @block="blockModal"
                        @unblock="unblockModal"
                        :stuffingDateFrom="stuffingDateRangeFrom"
                        :stuffingDateTo="stuffingDateRangeTo"
                        :orderLinkSTO="orderLinkSTO"
                        />
                </ScrollPanel>
            </div>
        </div>
    </CustomSidebar>    

    

</template>
<script>
    import ModalDataSAPOrder from '../Helper/_ModalDataSAPOrder.vue'
    import AssignTransporter from './_AssignTransporter.vue'

    export default{
        components: {
            'ModalDataSAPOrder': ModalDataSAPOrder,
            'AssignTransporter': AssignTransporter
        },
        emits:['close'],
        props:{
            data: {
                type: Object,
                default: null
            }
        },
        data(){
            return{
                showModal: false,
                orderData: null,
                sapOrders: [],
                sapOrdersDetail: [],
                dataUrl: "saporder/",
                blocked:false,
                assignModel: null,
                orderType: "",
                warehouseCode: "",
                shipmentType: "",
                documentType: "",
                transporterCode: "",
                isFirst: true,
                freightDate: null,
                showTransporterModal: false,
                isIndividual: false,
                isCollective: false,
                isRelation: false,
                transporters: [],
                transportersList: [],
                sapTransporter: false,
                selectTransporterNumTrip: 1,
                stuffingDate: [],
            }
        },
        mounted(){
            
        },
        methods:{
            reset(){
                this.orderData = null;
                this.sapOrders = [];
                this.sapOrdersDetail = [];
                this.addSAPNo = [];
                this.addSAPNoMessage= "";
                this.orderType = "";
                this.warehouseCode = "";
                this.shipmentType = "";
                this.documentType = "";
                this.isFirst = true;
                this.useLN = false;
                this.useSTO = false;
                this.relationTransporter = "";
            },
            blockModal(){
                this.blocked = true;
            },
            unblockModal(){
                this.blocked = false;
            },
            onShowModal(){
                this.reset();

                this.orderData = null;
                this.assignModel = null;
            
                this.blocked = true;
                this.showModal = true;

                var self = this;

                this.$axios.get(this.$API_URL + this.dataUrl + this.data.Id + "/" + this.$FORM_MODE_EDIT)
                    .then((response) => {
                        if (response.data.success) {
                            self.orderData = response.data.data.header;
                            self.assignModel = response.data.data.assign;

                            var det = {...self.assignModel.transporters};
                            self.transporters.push(det);

                            self.transporters[0].transporter_code = self.orderData.Customer_Vendor_Code;
                            self.transporters[0].transporter_name = self.orderData.customer_vendor_name;
                            self.transporters[0].truck_type_id = self.orderData.relation_truck_type_id;
                            self.transporters[0].freight_cost = 0;
                            self.transporters[0].freight_total_cost = 0;
                            self.transporters[0].freight_total_cost_user_not = 0;
                            self.transporters[0].freight_suggested = 0;
                            self.transporters[0].freight_container = 0;
                            self.transporters[0].freight_uom = "";

                            self.isIndividual = true;
                        }
                        else {
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                            self.showModal = false;
                        }
                        self.blocked = false;
                        
                    })
                    .catch(function (err) {
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        self.blocked = false;
                        self.showModal = false;
                    });
            },
            save(){
                this.assignModel.transporters = this.transporters;
                this.assignModel.details = this.orderData.Details;
                this.assignModel.id = [this.orderData.Id];
                this.blocked = true;

                if(this.assignModel.stuffing_date[1] == null){
                    this.assignModel.stuffing_date[1] = this.assignModel.stuffing_date[0];
                }

                var self = this;

                this.$axios.post(this.$API_URL + this.dataUrl + "assign_customer_vendor", this.assignModel)
                    .then((response) =>{
                        if (response.data.success) {
                            self.$emit('close');
                            self.$parent.$toast.add({ severity: 'success', summary: "Success", detail: response.data.message, life: 120000});
                            self.showModal = false;
                        }
                        else {
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                        }
                        self.blocked = false;
                    })
                    .catch((err) => {
                        //console.log(err);
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        self.blocked = false;
                        self.showModal = false;
                    });
            }
        },
        computed:{

        }


    }

</script>

